module.exports = "/dog-racing/img/vdh-progress.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/dog-racing/img/vdh-progress.png
// module id = 270
// module chunks = 7